var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"text",staticClass:"minisite-text-item text-00 ck-content",style:(_vm.getTextStyle),domProps:{"innerHTML":_vm._s(_vm.textContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }